import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Wrapper = styled.div`
    padding: 0;
`;

export const Inner = styled.div`
    ${breakpoints.large} {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }
`;

export const SortButtonContainer = styled.div`
    margin: 24px 0;
`;

export const TextContent = styled.div`
    ${breakpoints.large} {
        padding-right: 30px;
    }
`;

export const Title = styled.h3`
    color: ${colors.brandDark};
    margin-bottom: 0;
    font-weight: 800;
    font-size: 1.5rem;
`;

export const Content = styled.div`
    margin: 0;
    font-size: 16px;
    color: ${colors.brandDark};
    font-weight: 400;
    margin-top: 16px;

    p {
        margin: 0;
    }

    > *:last-child {
        margin-bottom: 0;
    }
`;

export const Controls = styled.div`
    display: block;
    text-align: center;
    margin-top: 24px;

    ${breakpoints.large} {
        display: flex;
        margin-top: 0;
        gap: 24px;
    }
`;

export const SearchAllContainer = styled.div`
    margin-top: 32px;
    text-align: center;
    ${breakpoints.large} {
        margin-top: 40px;
    }
`;
